import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

const { PROCEDURE_SHARED_URI } = environment;

@Injectable({
  providedIn: 'root'
})
export class CityService {

  constructor(private http: HttpClient) {
  }

  getDepartaments(): Observable<any> {
    return this.http.get(`${PROCEDURE_SHARED_URI}/v1/Departamento/GetDepartamento`);
  }

  getMunByDepaId(depaId: number): Observable<any> {
     return this.http.get(`${PROCEDURE_SHARED_URI}/v1/Municipio/GetMunicipioByIdDepartamento/${ depaId }`);
  }
}
